import React from "react";
import {
  SafetyCertificateOutlined,
  CustomerServiceOutlined,
  BarChartOutlined,
  CreditCardOutlined,
  AppstoreOutlined,
  DeploymentUnitOutlined,
  RiseOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import Slide from "react-reveal/Slide";

const whyChooseUs = [
  {
    icon: <SafetyCertificateOutlined />,
    title: "Industry Expertise",
    desc: "Years of experience delivering inventory and accounting software for businesses of every size.",
  },
  {
    icon: <CustomerServiceOutlined />,
    title: "24/7 Support",
    desc: "Our dedicated support team is always available whenever your business needs assistance.",
  },
  {
    icon: <DeploymentUnitOutlined />,
    title: "Tailored Solutions",
    desc: "Flexible workflows and customization designed around your business operations.",
  },
  {
    icon: <AppstoreOutlined />,
    title: "Secure & Scalable",
    desc: "Enterprise-grade security with infrastructure that grows alongside your company.",
  },
  {
    icon: <ThunderboltOutlined />,
    title: "Easy To Use",
    desc: "An intuitive interface that requires little or no training for your staff.",
  },
  {
    icon: <CreditCardOutlined />,
    title: "Flexible Pricing",
    desc: "Affordable monthly and yearly plans with no hidden charges.",
  },
  {
    icon: <BarChartOutlined />,
    title: "Powerful Reports",
    desc: "Real-time dashboards and analytics to help you make better business decisions.",
  },
  {
    icon: <RiseOutlined />,
    title: "Business Growth",
    desc: "Automate operations, increase productivity and improve profitability.",
  },
];

const InventoryWhyChooseUsComp = () => {
  return (
    <section className="relative overflow-hidden bg-white py-24">

      {/* Background Decorations */}

      <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-red-100 blur-[140px]" />

      <div className="absolute right-0 bottom-0 h-[420px] w-[420px] rounded-full bg-orange-100 blur-[150px]" />

      <div className="relative max-w-7xl mx-auto px-6">

        {/* Header */}

        <div className="max-w-3xl mx-auto text-center">

          <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-5 py-2">

            <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" />

            <span className="font-semibold text-red-600 text-sm">
              Why Businesses Choose SupaRecords
            </span>

          </div>

          <h2 className="mt-8 text-5xl lg:text-6xl font-black leading-tight text-slate-900">

            Built For Growing

            <span className="block bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500 bg-clip-text text-transparent">

              Modern Businesses

            </span>

          </h2>

          <p className="mt-8 text-lg leading-8 text-gray-600">

            Everything you need to simplify inventory, sales,
            accounting, purchasing and reporting—backed by
            reliable support and enterprise-grade security.

          </p>

        </div>

        {/* Content */}

        <div className="mt-20 grid gap-20 lg:grid-cols-2 items-center">

          {/* LEFT */}

          <div className="grid gap-6 sm:grid-cols-2">

            {whyChooseUs.map((item, index) => (

              <Slide bottom delay={index * 50} key={index}>

                <div className="group rounded-3xl border border-gray-200 bg-white p-7 shadow-sm transition-all duration-500 hover:-translate-y-2 hover:border-red-300 hover:shadow-2xl">

                  <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-red-600 to-orange-500 text-3xl text-white shadow-lg">

                    {item.icon}

                  </div>

                  <h3 className="mt-6 text-xl font-bold text-slate-900">

                    {item.title}

                  </h3>

                  <p className="mt-4 leading-7 text-gray-600">

                    {item.desc}

                  </p>

                </div>

              </Slide>

            ))}

          </div>

          {/* RIGHT */}

          <Slide right>

            <div className="relative flex justify-center">

              <img
                src={`${process.env.PUBLIC_URL}/images/site/about1.jpg`}
                alt="Why Choose SupaRecords"
                className="relative z-10 w-full max-w-lg rounded-[32px] border border-gray-200 shadow-[0_30px_80px_rgba(0,0,0,.08)]"
              />

              {/* Floating Card */}

              <div className="absolute -left-6 top-10 rounded-3xl border border-gray-200 bg-white p-5 shadow-2xl">

                <p className="text-sm text-gray-500">
                  Customer Satisfaction
                </p>

                <h3 className="mt-1 text-4xl font-black text-red-600">
                  99%
                </h3>

              </div>

              {/* Floating Card */}

              <div className="absolute -right-6 bottom-12 rounded-3xl border border-gray-200 bg-white p-5 shadow-2xl">

                <p className="text-sm text-gray-500">
                  Cloud Uptime
                </p>

                <h3 className="mt-1 text-4xl font-black text-red-600">
                  99.9%
                </h3>

              </div>

            </div>

          </Slide>

        </div>

        {/* Bottom Stats */}

        <div className="mt-24 rounded-[40px] bg-gradient-to-r from-red-600 via-red-500 to-orange-500 p-10 text-white">

          <div className="grid gap-10 md:grid-cols-4 text-center">

            <div>

              <h3 className="text-5xl font-black">
                24/7
              </h3>

              <p className="mt-2 opacity-90">
                Customer Support
              </p>

            </div>

            <div>

              <h3 className="text-5xl font-black">
                Cloud
              </h3>

              <p className="mt-2 opacity-90">
                Secure Platform
              </p>

            </div>

            <div>

              <h3 className="text-5xl font-black">
                Live
              </h3>

              <p className="mt-2 opacity-90">
                Business Reports
              </p>

            </div>

            <div>

              <h3 className="text-5xl font-black">
                Multi
              </h3>

              <p className="mt-2 opacity-90">
                Warehouse Ready
              </p>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default InventoryWhyChooseUsComp;